import { Action } from 'redux';
export const VIDEOPLAYER_OPEN = 'VIDEOPLAYER_OPEN';
export const VIDEOPLAYER_CLOSE = 'VIDEOPLAYER_CLOSE';

interface VideoParams {
  id: string;
  title: string;
}

export type VideoAction = VideoParams & Action;
export const openVideo = ({ id, title }: VideoParams): VideoAction => ({
  id,
  title,
  type: VIDEOPLAYER_OPEN
});

export const closeVideo = (): Action => ({
  type: VIDEOPLAYER_CLOSE
});
